import React, { memo } from "react";

// Classnames
import clsx from "clsx";

// components
import NoData from "components/NoData";
import Loader from "components/UiKit/Loader";
import CartLibrariesCompounds from "components/Carts/CartLibrariesCompounds";

// Type
import { Compound } from "lib/prices";

type TList = {
  loading: boolean,
  data: Compound[],
}

export const List: React.FC<TList> = (props) => {
  const { data, loading } = props;

  const cnWrapper = clsx(
    "libraries-compounds__list flex flex-jc-between flex-direction-column",
  );

  const getNoData = () => {
    return <div
      className="flex flex-ai-center flex-jc-center mt30"
    >
      <NoData text="No data available" />
    </div>;
  };

  const getList = (data: Compound[]) => {
    return data?.map(
      (item: Compound, index: number) => {
        const numeration = index + 1;
        return (
          <CartLibrariesCompounds
            {...item}
            key={index}
            numeration={numeration}
          />
        );
      });
  };

  const getLoader = () => {
    return <div className="libraries-compounds__loader relative mt30 mb30 full-width">
      <Loader type="bio"/>
    </div>;
  };

  return (
    <div className={cnWrapper}>
      {loading ?
        getLoader()
        :
        data?.length
          ? getList(data)
          : getNoData()}
    </div>
  );
};

export default memo(List);
